import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {CLOSE__12} from '@homeaway/svg-defs/lib/defs/CLOSE__12';
import {SVGIcon} from '@homeaway/react-svg';

export class Attachment extends React.Component {
    static propTypes = {
        error: PropTypes.bool,
        file: PropTypes.shape(),
        id: PropTypes.number,
        name: PropTypes.string,
        onRemove: PropTypes.func,
    };

    static defaultProps = {
        error: false,
        onRemove: () => {},
    };

    removeToken = (event) => {
        event.preventDefault();
        this.props.onRemove(this.props.id);
    };

    render() {
        const tokenClassName = classNames('Token', {
            'Token--error': this.props.error,
        });

        // This is bad... This token styling comes from react-input-tokenize
        // We should export a <Token> from that
        return (
            <div className="Attachment">
                <div className={tokenClassName}>
                    <span className="Token__value">
                        <strong>{this.props.name}</strong>
                    </span>
                    <button
                        className="Token__remove"
                        onClick={this.removeToken}
                    >
                        <SVGIcon markup={CLOSE__12} />
                    </button>
                </div>
            </div>
        );
    }
}
